import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

import { HemsFlattenedFeatures, powerChartFeatures } from '@vi-iot/client';

import { EnergyHistoricalDataStore, SelectableFeature } from '@store';

@Component({
  selector: 'app-energy-history-chart-legend',
  templateUrl: './energy-history-chart-legend.component.html',
  styleUrls: ['./energy-history-chart-legend.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EnergyHistoryChartLegendComponent implements OnInit {
  selectableFeatures: SelectableFeature[];
  chartFeatures = powerChartFeatures;

  constructor(
    public energyHistoricalDataStore: EnergyHistoricalDataStore,
    private translateService: TranslateService
  ) {}

  ngOnInit(): void {
    this.createSelectableFeatures();
  }

  private createSelectableFeatures(): void {
    let flattenedFeatures: HemsFlattenedFeatures[] = [];

    this.chartFeatures.forEach((entry) => {
      flattenedFeatures = flattenedFeatures.concat(entry.features);
    });
    this.selectableFeatures = flattenedFeatures.map((feature) => ({
      name: feature.feature,
      displayName: this.translateService.instant(`+HEMS_FEATURES.${feature.feature.toUpperCase()}`),
      checked: false,
    }));
  }
}
